function DraggableEvents() {
	this.build();
	resizeCallbacks.push(this);
}

DraggableEvents.prototype.build = function () {
	Draggable.create(".draggable-events", {
		type: "scrollLeft",
		inertia: true
	});
};

DraggableEvents.prototype.resize = function () {
	this.destroy();
	this.build();
};

DraggableEvents.prototype.destroy = function () {

};
